import { Reducer } from "redux";
import { ActionTypes, AreaActions } from "./AreaActionTypes";
import { AreaState, IAreaState } from "./AreaState";

export const initialState: IAreaState = new AreaState();

const reducer: Reducer<IAreaState> = (state: IAreaState = initialState, action: AreaActions) => {
    switch (action.type) {
        case ActionTypes.AREAS_RETRIEVED:
            return { ...state, companyAreas: action.data };

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/Areas/AreaReducer.ts